export const FETCH_OUTREACH_PAGE = '@@homepage/FETCH_OUTREACH_PAGE';
export const FETCH_OUTREACH_PAGE_SUCCESS = '@@homepage/FETCH_OUTREACH_PAGE_SUCCESS';
export const FETCH_OUTREACH_PAGE_ERROR = '@@homepage/FETCH_OUTREACH_PAGE_ERROR';
